import { mutatorAction } from 'satcheljs';
import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import type { ActivityFeedSettingIds } from '../service/ActivityFeedSettingType';
export const changeActivityFeedSettingValue = mutatorAction(
    'CHANGE_ACTIVITY_FEED_SETTING_VALUE',
    (activityFeedSetting: ActivityFeedSettingIds, newSettingValue: boolean) => {
        getActivityFeedSettingsStore().set(activityFeedSetting, newSettingValue);
    }
);
